module.exports = __webpack_public_path__ + "img/homepage_header_scaled.f15b389b.png";